import { Component, OnInit, Input } from '@angular/core';
import { UserblockService } from './userblock.service';
import { ThemesService } from '../../../core/themes/themes.service';
import { ProfilePictureService } from "../../../profile-picture/profile-picture.service";

@Component({
  selector: 'app-loggeduserblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {
  private user: any = {};
  userHasPicture: boolean = false;
  constructor(public userblockService: UserblockService,
  private themesService: ThemesService,
  private profilePictureService: ProfilePictureService) { }

  ngOnInit() {
    this.userblockService.getLoggedUser().subscribe(user => {
      this.user = user;
      this.userHasPicture = user.picture !== null && user.picture !== undefined && user.picture !== '';
      let userTheme = user.layoutThemeName;
      if(userTheme){
        this.themesService.setTheme(userTheme);
      }
    });
    this.profilePictureService.currentProfilePicture.subscribe(picture => {this.user.picture = picture; this.userHasPicture = this.user.picture !== null});
  }
  userBlockIsVisible() {
    return this.userblockService.getVisibility();
}
  
}
